export class homeLabel_HN {

    home: {
        createNewQuotation: string;
        createUsedQuotation: string;
        searchQuotation: string;
        trackQuotation: string;
        pendingTasks: string;
        dealershipDetails: string;
        myProfile: string;
        recent: string;
        notifications: string;
        status: string;
    }

    admin: {
        master: string;
        broadcast: string;
        userAdmin: string;
        dashboardAdmin:string;
        configuratorAdmin:string;
        imageUploads:string;
        taskManager:string;
        faq:string;
        dealerData:string;
    }

    constructor() {

        this.home = {
            createNewQuotation: "नई कार कोटेशन",
            createUsedQuotation: "प्रयुक्त कार कोटेशन",
            searchQuotation: "कोटेशन खोजें",
            trackQuotation: "ट्रैक एप्लिकेशन",
            pendingTasks: "लंबित कार्य",
            dealershipDetails: "डीलरशिप विवरण",
            myProfile: "मेरी प्रोफाइल",
            recent: "हाल की गतिविधियां",
            notifications: "सूचनाएं",
            status: "रिपोर्ट"
        }

        this.admin = {
            master: "मास्टर डेटा सिंक",
            broadcast: "प्रसारण",
            userAdmin: "उपयोगकर्ता",
            dashboardAdmin:"डैशबोर्ड",
            configuratorAdmin:"कौन्फ़िगरेटर",
            imageUploads:"छवि अपलोड",
            taskManager:"कार्य प्रबंधक",
            faq:"सामान्य प्रश्न",
            dealerData:"डीलर डेटा अपलोड"
        }
    }
}